<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import type { Notebook } from '@prisma/client'
import { useDocument } from '~/store/document'
import { type LordIcon, LordIconSource, LordIconTrigger } from '~/types/assets'
import type { FileNode } from '~/types/custom'
import { useLocaleThemePath } from '~/composables/locale'

const { documents } = storeToRefs(useDocument())

const documentFiles = computed((): FileNode[] =>
  documents.value
    .filter(
      (doc) => (doc.name.includes('.md') || doc.name.includes('.ipynb')) && !doc.name?.toLowerCase()?.includes('readme')
    )
    .map(
      (doc: Notebook): FileNode =>
        doc.location
          ? { name: doc.location, path: useLocaleThemePath(`/assets/docs/${doc.location}`) }
          : { name: doc.name, path: useLocaleThemePath(`/assets/docs/${doc.name}`) }
    )
)

const bookIcon: LordIcon = {
  src: LordIconSource?.book,
  trigger: LordIconTrigger?.loop,
  revert: true,
  delay: 500,
  size: 55,
  loading: 'lazy'
}
</script>

<template lang="pug">
div.assets__alpha
  h1 {{ $t('assets.alpha.title') }}
  .assets__alpha__content
    .assets__alpha__content__tree
      UITree(:paths="documentFiles")
      span
        IconLord(v-bind="bookIcon")
</template>

<style lang="sass" scoped>
div.assets__alpha
  @apply w-full h-full flex-center flex-col  px-4
  h1
    @apply text-center text-2xl lg:text-4xl font-bold text-primary mb-8 text-animated
  .assets__alpha__content
    @apply w-full flex justify-center items-start gap-4
    .assets__alpha__content__text
      @apply max-w-[45%]
      p
        @apply text-white mt-4
      a
        @apply text-lg text-secondary underline
      .assets__alpha__content__text__scroll
        @apply max-h-[300px] overflow-y-auto scrollbar-primary border-b border-l border-primary p-2 rounded-b-lg mt-4 mb-4
  .assets__alpha__content__tree
    @apply relative
    span
      @apply hidden lg:block absolute bottom-0 right-0 bg-dark-800 rounded-[25px] p-1 border-4 border-double border-secondary translate-x-[15%] translate-y-[15%]
</style>
